<template>
<div class="fixed-btn">
	<button class="fixed-btn__static" type="button" @click="hide = true">Свернуть</button>
	<teleport to="body">
		<transition name="fixed-btn">
			<button v-if="hide" @click="hide = false" class="fixed-btn__fixed" type="button">
				<svg class="fixed-btn__fixed-icon">
					<use href="#svg-icon-history-back"></use>
				</svg>
			</button>
		</transition>
	</teleport>
</div>

</template>

<script>

export default {
	emits: [
		'hide-state'
	],

	data() {
		return {
			hide: false
		}
	},

	watch: {
		hide(state) {
			this.$emit('hide-state', state);
		}
	}
}

</script>